export default __webpack_public_path__ + "static/media/vehicle.06e8457d.png";